module.exports = {"StatusCode":200,"Payload":"[{}]"}


//////////////////
// WEBPACK FOOTER
// ./src/payloads/aws/lambda/mocks/empty.json
// module id = 1gJF
// module chunks = 0